import { includes } from 'ramda'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { UserStatus } from '$common/user-status'
import { useUser } from '$logic/users'
import { WithQueryTitleBase } from '../with-query-title-base'

const StyledBox = styled(Box)`
  margin-right: 4px;
`

export function WithQueryUserListItemStatus({
  userId,
  query,
}: {
  userId?: string
  query: string
}) {
  const { user } = useUser(userId)

  const id = user?.username ? `${user.username}@` : ''
  const queryIncludesId = id ? includes(query, id) : false

  return queryIncludesId ? (
    <StyledBox>
      <WithQueryTitleBase
        query={query}
        title={id}
        variant="caption1"
        color="neutral500"
      />
    </StyledBox>
  ) : (
    <UserStatus userId={userId} textColor="neutral500" />
  )
}
